import { useCallback } from "react";
import { usePunditUserContext } from "@circle-react/contexts";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@circle-react/helpers/communityMemberHelpers";
import type { Topic } from "@circle-react/types/Topic";

interface UseTopicsPermissionsProps {
  creatable?: boolean;
  deletable?: boolean;
}

export const useTopicsPermissions = ({
  creatable = false,
  deletable = true,
}: UseTopicsPermissionsProps) => {
  const { currentCommunityMember } = usePunditUserContext();

  const canManageTopics =
    isCommunityAdmin(currentCommunityMember) ||
    isCommunityModerator(currentCommunityMember);

  const canSelectTopic = useCallback(
    (topic: Topic) => canManageTopics || !topic.admin_only,
    [canManageTopics],
  );

  const canRemoveTopic = useCallback(
    (topic: Topic) => deletable && (canManageTopics || !topic.admin_only),
    [canManageTopics, deletable],
  );

  return {
    canSelectTopic,
    canRemoveTopic,
    canCreateTopics: creatable,
    canRemoveAllTopics: deletable,
  };
};
